//@ts-ignore
const List = ({ children }) => children;

export default List;
